import { dequal } from 'dequal'

import type { AutomationAnalysis } from '../../simulation.types'

/** What a round of fetching is keyed on, as of one render. */
export type ResolveInputSnapshot = {
  analysis: AutomationAnalysis | undefined
  isEnabled: boolean
  useCacheValueForKey: string
  workflowInputKey: string
}

/**
 * Whether anything a round of fetching depends on has actually changed since
 * the last render. Nothing here means the re-render was for some other reason
 * and there's no new answer to go and get.
 *
 * The analysis is compared on its contents rather than its identity. It's
 * rebuilt whenever the automation query hands back a new object, which happens
 * on any background refetch, and re-fetching every dependency because an equal
 * analysis arrived would be a lot of requests for the same answer.
 */
export const haveResolveInputsChanged = ({
  previous,
  current
}: {
  previous: ResolveInputSnapshot | undefined
  current: ResolveInputSnapshot
}): boolean =>
  !previous ||
  previous.isEnabled !== current.isEnabled ||
  previous.workflowInputKey !== current.workflowInputKey ||
  previous.useCacheValueForKey !== current.useCacheValueForKey ||
  !dequal(previous.analysis, current.analysis)
